import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { EditionType } from '@graphics/gfx-common/dist/constants'
import { IEditionMetadata, PackType } from '../../types/pack'
import { selectEdition } from '../../selectors/pack'
import { getPreviewImages, getPromoDestinations } from '../../services/pack'
import { Scrollable, DetailsTemplate, Space } from '../../layouts'
import {
  ThumbnailPreview,
  H2,
  DetailsPanel,
  PackDeleteButton,
  FileDeleteButton,
} from '../../components'
import { LocationsDetails } from './LocationsDetails'
import { SharingActions } from './SharingActions'
import { SharingDetails } from './SharingDetails'
import trPlaceholder from '../../assets/tr-placeholder.jpg'

export interface IFileDetailsTabComponent {
  pack: PackType
  edition?: IEditionMetadata
  isLightGroup?: boolean
  dispatch: Dispatch
}

export const FileDetailsTabComponent = ({
  pack,
  edition,
  isLightGroup,
  dispatch,
}: IFileDetailsTabComponent) => {
  if (!edition) {
    return null
  }
  const { thumbnailURI = trPlaceholder } = getPreviewImages(
    edition.useGraphicPreview ? pack : edition
  )
  const {
    published: isPublished,
    publishing: isPublishing,
  } = edition.publishing
  const isDataSteamGraphics =
    edition.editionType === EditionType.DataStreamGraphic
  const isPromotedTo = getPromoDestinations(edition)
  return (
    <Scrollable>
      <DetailsTemplate
        aside={
          <>
            <H2 mb={4}>Metadata</H2>
            <Space mb={4} pl={6} pr={6} pb={6} pt={6}>
              <ThumbnailPreview src={thumbnailURI} />
            </Space>
            <>
              <DetailsPanel
                pack={pack}
                edition={edition}
                isDataSteamGraphics={isDataSteamGraphics}
              />
              {isLightGroup ? (
                <PackDeleteButton pack={pack} />
              ) : (
                <FileDeleteButton pack={pack} edition={edition} />
              )}
            </>
          </>
        }
        contentProps={{ id: 'edition-details-tab-main' }}
        asideProps={{ id: 'edition-details-tab-aside' }}
      >
        <LocationsDetails pack={pack} edition={edition} />
        {(isPublished || isPublishing) && (
          <SharingDetails edition={edition} isPromotedTo={isPromotedTo} />
        )}
        {isPublished && (
          <SharingActions
            edition={edition}
            isPromotedTo={isPromotedTo}
            pack={pack}
          />
        )}
      </DetailsTemplate>
    </Scrollable>
  )
}

const mapStateToProps = (state, ownProps) => ({
  edition: selectEdition(ownProps.editionId)(state),
})

export const FileDetailsTab = connect(mapStateToProps)(FileDetailsTabComponent)
